import React from 'react';
import { DateTime } from 'luxon';
import { PayloadStates } from '@lore/utils';
import MissingField from '../project-manage/MissingField';
import HiddenField from '../project-manage/HiddenField';
import useMissingFields from './useMissingFields';

export default function MissingFields(props) {
  const { offer } = props;

  const { missingFields } = useMissingFields(offer);

  if (missingFields.state === PayloadStates.FETCHING) {
    return null;
  }

  if (
    missingFields.data.length > 0
  ) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {missingFields.data.map(function(missingField) {
          return (
            <MissingField
              key={missingField.key}
              name={missingField.name}
              description={(
                <>
                  You must provide this field before you can connect with educators,
                  or before your offer will be shown to others.
                </>
              )}
              to={missingField.to}
            />
          );
        })}
      </div>
    );
  }

  const inPast = (
    offer.data.specificDate === 'Yes' &&
    offer.data.date &&
    DateTime.now().diff(DateTime.fromISO(offer.data.date)).milliseconds > 0
  ) || (
    offer.data.endDate &&
    DateTime.now().diff(DateTime.fromISO(offer.data.endDate)).milliseconds > 0
  );

  if (inPast) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <HiddenField
          name="Your offer has expired!"
          description={(
            <>
              Educators can no longer see your offer because it's set in the
              past. Change the date to make it visible again.
            </>
          )}
          to={`/post-offer/${offer.id}/date`}
        />
      </div>
    );
  }

  return null;
};
